import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ContractStates } from "../utils/constants/common";
import { useDispatch, useSelector } from "react-redux";
import { addCommercialContract, buyerConfirm, sellerConfirm, updateCommercialDB, updateCommmercialDB2 } from "../Redux/products/slice";
import { toast } from "react-toastify";
import { select } from "redux-saga/effects";
import { ToastProperties } from '../utils/constants/toastProperties';
import { MantineProvider, Stepper  } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IntlProvider, FormattedMessage, useIntl } from 'react-intl';

export default function UpdateContractModal({ open = false, toggle, isUpdate, selected }) {

  const dispatch = useDispatch();
  const { updateCommercialMessage } = useSelector(state => state.products);
  const filtedState = (s) => ContractStates.find(ec => ec.id === s);

  const [selectedState, setSelectedState] = useState(filtedState(selected.contractState));
  const [updating, setUpdating] = useState({});
  const isSmallScreen = useMediaQuery('(max-width: 768px)'); 

  const handleSave = () => {
    console.log({ selected })
    const payload = {
      ...selected,
      "CONTRACTID": selected.contractId,
      BUYERID: selected.BuyerID,
      SELLERID: selected.SellerID,
      ...updating
    }
    dispatch(updateCommercialDB(payload));
  }

  const handleAllSubjects = () => {
    const userinfo = JSON.parse(localStorage.getItem('userinfo'));
    const payload = {
      ...selected,
      "CONTRACTID": selected.contractId,
      BUYERID: selected.BuyerID,
      SELLERID: selected.SellerID,
      "state": "AllSubjectsLifted",
      requestUserId: userinfo.userId,
      ownerAccountID: userinfo.accountId,
      productRefId: selected.productRefID,
    }
    dispatch(updateCommmercialDB2(payload))
  }

  const handleSellerSign = () => {
    const userinfo = JSON.parse(localStorage.getItem('userinfo'));
    dispatch(sellerConfirm({
      contractId: selected.contractId,
      sku: selected.sku,
      requestUserId: userinfo.userId,
      ownerAccountID: userinfo.accountId,
      state: selected.contractState,
      productRefId: selected.productRefID,
      BuyerID: selected.BuyerID,
      contractRefId: selected.contractRefID,
    }))

    setTimeout(() => {
      toggle()
    }, 3000)
  };

  const handleBuyerSign = () => {
    const userinfo = JSON.parse(localStorage.getItem('userinfo'));
    dispatch(buyerConfirm({
      contractId: selected.contractId,
      sku: selected.sku,
      requestUserId: userinfo.userId,
      ownerAccountID: userinfo.accountId,
      state: selected.contractState,
      productRefId: selected.productRefID,
      BuyerID: selected.BuyerID,
      contractRefId: selected.contractRefID,
    }))

    setTimeout(() => {
      toggle()
    }, 3000)
  };

  const updatePayload = () => {
    // console.log({ value, requiredPayload })
    // return { ...value, ...requiredPayload, productRefId: value.productID };
    const userinfo = JSON.parse(localStorage.getItem('userinfo'))
    return {
      productRefId: selected.productRefID,
      contractId: selected.contractId,
      sellerId: selected.SellerID,
      buyerId: selected.BuyerID,
      contractDetails: selected.contractDetails,
      price: selected.price,
      location: selected.location,
      period: selected.period,
      quantity: selected.quantity,
      productNotes: selected.productNotes,
      requestUserId: userinfo.userId,
      ownerAccountID: userinfo.accountId,
      contractRefId: selected.contractRefID,
    }
  };

  const handleConfirmOrder = () => {
    if (selected.contractState === "Completed") {
      toast.info("You cannot confirm order as this contract is already completed", {
        ...ToastProperties
      })
    } else if  (selected.contractState === "Draft") {
      toast.info("You cannot confirm as there is no Buyer, this is a draft contract", {
        ...ToastProperties
      })
    } else {
      dispatch(addCommercialContract(updatePayload()));
    }

    setTimeout(() => {
      toggle()
    }, 3000)

  };

  const setNewValues = (k, v) => {
    setUpdating(e => ({
      ...e,
      [k]: v
    }))
  }

  const isUpdateDisabled = useMemo(() => {
    return selected.contractState === 'Completed' || selected.contractState === 'allsubjectlifted'
  }, [selected.contractState])

  const isDisabled = useMemo(() => {
    return selected.contractState === 'Completed' || selected.contractState === 'allsubjectlifted' || selected.contractState === 'Draft'
  }, [selected.contractState])

  useEffect(() => {
    if (updateCommercialMessage) {
      toggle()
    }
  }, [updateCommercialMessage]);

  const [userinfo, setUserinfo] = useState(null);

  // Fetch user info from local storage on component mount
  useEffect(() => {
    const storedUserinfo = JSON.parse(localStorage.getItem("userinfo"));
    setUserinfo(storedUserinfo);
  }, []);

  const intl = useIntl();

  const getStepperStep = () => {
    if (!userinfo) return 0;
    
    const isBuyer = userinfo.userId === selected.BuyerID;
    const isSeller = userinfo.userId === selected.SellerID;
  
    switch (selected.contractState) {
      case 'Draft':
        return 0;
      case 'InNegotiation':
        return 0;
      case 'OnSubjects':
        return 1;
      case 'AllSubjectsLifted':
        return 2;
      case 'ConfirmedByBuyer':
        // If user is buyer, show they've completed their step
        // If user is seller, show it's their turn
        return isBuyer ? 3 : 2;
      case 'ConfirmedBySeller':
        // If user is seller, show they've completed their step
        // If user is buyer, show it's their turn
        return isSeller ? 3 : 2;
      case 'Completed':
        return 4;
      default:
        return 0;
    }
  };

  return (
    <>
      <Modal isOpen={open} toggle={toggle} style={{ height: "auto", maxWidth: "80%" }}>
        <ModalHeader><FormattedMessage id="modal.updateContract.title" /></ModalHeader>
        <ModalBody>
          <Grid item>
            <Grid container>
              <Grid item mb="10pt">
                <TextField
                  id="outlined-basic"
                  label={intl.formatMessage({ id:"product.id" })}
                  aria-readonly
                  variant="outlined"
                  defaultValue={selected.productSKU}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <Grid item mb="10pt">
                <TextField
                  id="outlined-basic"
                  label={intl.formatMessage({ id:"product.period" })}
                  variant="outlined"
                  defaultValue={selected.period}
                  onChange={e => setNewValues('period', e.target.value)}
                  InputProps={{
                    readOnly: true && !isUpdate,
                  }}
                />
              </Grid>
              <Grid item mb="10pt">
                <TextField
                  id="outlined-basic"
                  label={intl.formatMessage({ id:"product.quantity" })}
                  variant="outlined"
                  defaultValue={selected.quantity}
                  onChange={e => setNewValues('quantity', e.target.value)}
                  InputProps={{
                    readOnly: true && !isUpdate,
                  }}
                />
              </Grid>
              <Grid item mb="10pt">
                <TextField
                  id="outlined-basic"
                  label={intl.formatMessage({ id:"product.price" })}
                  variant="outlined"
                  defaultValue={selected.price}
                  onChange={e => setNewValues('price', e.target.value)}
                  InputProps={{
                    readOnly: true && !isUpdate,
                  }}
                />
              </Grid>
              <Grid item mb="10pt">
                <TextField
                  id="outlined-basic"
                  label={intl.formatMessage({ id:"product.location" })}
                  variant="outlined"
                  defaultValue={selected.location}
                  onChange={e => setNewValues('location', e.target.value)}
                  InputProps={{
                    readOnly: true && !isUpdate,
                  }}
                />
              </Grid>
              <Grid item mb="10pt">
                <TextField
                  id="outlined-basic"
                  label={intl.formatMessage({ id:"product.notes" })}
                  variant="outlined"
                  defaultValue={selected.productNotes}
                  onChange={e => setNewValues('productNotes', e.target.value)}
                  InputProps={{
                    readOnly: true && !isUpdate,
                  }}
                />
              </Grid>
              <Grid item mb="10pt">
                <TextField
                  id="outlined-basic"
                  label={intl.formatMessage({ id:"contract.details" })}
                  variant="outlined"
                  defaultValue={selected.contractDetails}
                  onChange={e => setNewValues('contractDetails', e.target.value)}
                  InputProps={{
                    readOnly: true && !isUpdate,
                  }}
                />
              </Grid>
              <Grid item mb="10pt">
              </Grid>
            </Grid>
          </Grid>
        </ModalBody>
        <ModalFooter style={{ display: "flex", justifyContent: "center" }}>
          {
            isUpdate && <>
              <Button color="primary" disabled={isUpdateDisabled || (userinfo && userinfo.userId === selected.BuyerID)} onClick={handleSave}>
                <FormattedMessage id="button.save" />
              </Button>
              <Button color="danger" disabled={isUpdateDisabled} onClick={toggle}>
              <FormattedMessage id="button.cancel" />
              </Button>
            </>
          }
          {!isUpdate && <>
            <Button 
              disabled={isDisabled || userinfo?.userId === selected.SellerID || selected.contractState !== 'InNegotiation'} 
              color="success" onClick={handleConfirmOrder}>
              <FormattedMessage id="button.confirmorder" />
            </Button>
            <Button 
              disabled={isDisabled || selected.contractState !== 'OnSubjects'} 
              color="info" onClick={handleAllSubjects}>
              <FormattedMessage id="button.liftallsubjects" />
            </Button>
            <Button 
              disabled={isDisabled || userinfo?.userId === selected.SellerID || !(selected.contractState === 'ConfirmedBySeller' || selected.contractState === 'AllSubjectsLifted')} 
              color="warning" onClick={handleBuyerSign}>
              <FormattedMessage id="button.buyersign" />
            </Button>
            <Button 
              disabled={isDisabled || userinfo?.userId === selected.BuyerID || !(selected.contractState === 'ConfirmedByBuyer' || selected.contractState === 'AllSubjectsLifted')} 
              color="primary" onClick={handleSellerSign}>
              <FormattedMessage id="button.sellersign" />
            </Button>
          </>}
        </ModalFooter>
        <MantineProvider 
            withGlobalStyles
            withNormalizeCSS
            theme={{
              primaryColor: 'blue',
              defaultRadius: 'md',
              components: {
                Stepper: {
                  styles: {
                    root: {
                      margin: '0 auto',
                      width: '100%',
                      maxWidth: '1200px', // Adjust this value based on your needs
                    },
                    separator: {
                      borderTop: '2px solid #dee2e6',
                      marginLeft: '4px',
                      marginRight: '4px',
                      height: '2px'
                    },
                    separatorActive: {
                      borderTopColor: 'var(--mantine-primary-color-6)'
                    },
                    steps: {
                      gap: '4px',
                      padding: '8px 0'
                    }
                  }
                }
              }
            }}
          >
              <div style={{  margin: "20px auto",  // Auto margins for horizontal centering
                    padding: "0 24px",    // Horizontal padding to prevent edge touching
                    maxWidth: "90%"  }}>
              <Stepper 
                  active={getStepperStep()} 
                  size="xs"
                  orientation={isSmallScreen ? 'vertical' : 'horizontal'}
                  styles={{
                    root: {
                      padding: '12px 0',
                    },
                    separator: {
                      marginLeft: '4px',
                      marginRight: '4px',
                      height: isSmallScreen ? '100%' : '2px',
                      borderTop: !isSmallScreen ? '2px solid #dee2e6' : 'none',
                      borderLeft: isSmallScreen ? '2px solid #dee2e6' : 'none'
                    },
                    separatorActive: {
                      borderTopColor: !isSmallScreen ? 'var(--mantine-color-blue-6)' : 'none',
                      borderLeftColor: isSmallScreen ? 'var(--mantine-color-blue-6)' : 'none'
                    },
                    steps: {
                      gap: '12px'
                    },
                    step: {
                      padding: isSmallScreen ? '12px' : '0'
                    }
                  }}
                  color="blue"
                >
                  <Stepper.Step 
                    label={<FormattedMessage id="button.confirmorder" />}
                    // description={<FormattedMessage id="stepper.description.confirmorder" />}
                  />
                  <Stepper.Step 
                    label={<FormattedMessage id="button.liftallsubjects" />}
                    // description={<FormattedMessage id="stepper.description.liftsubjects" />}
                  />
                  <Stepper.Step 
                    label={userinfo?.userId === selected.BuyerID ? 
                      <FormattedMessage id="button.buyersign" /> : 
                      <FormattedMessage id="button.sellersign" />}
                    // description={userinfo?.userId === selected.BuyerID ? 
                    //   <FormattedMessage id="stepper.description.buyerconfirm" /> : 
                    //   <FormattedMessage id="stepper.description.sellerconfirm" />}
                  />
                  <Stepper.Step 
                    label={userinfo?.userId === selected.BuyerID ? 
                      <FormattedMessage id="button.sellersign" /> : 
                      <FormattedMessage id="button.buyersign" />}
                    // description={userinfo?.userId === selected.BuyerID ? 
                    //   <FormattedMessage id="stepper.description.sellerconfirm" /> : 
                    //   <FormattedMessage id="stepper.description.buyerconfirm" />}
                  />
                </Stepper>
              </div>
            </MantineProvider>
      </Modal>
    </>
  );
}